import { EventBroker } from "@/frontend/lib/utils/event-broker";

export const LAYOUT_SAVE_EVENTS = {
  SAVED: 'SAVED',
}

export const layoutSaveEventBroker = new EventBroker();
